import React, { Component, Fragment } from 'react';
import ConfigAdmin from '../../config/configAdmin';
import AdminRoutes from '../../Routes/AdminRoutes';
import AnimationLoader from './templates/AnimationLoader';
import Footer from './templates/Footer';
import Navbar from './templates/Navbar';
import Sidebar from './templates/Sidebar';

class Admin extends Component {
    state = {
        aksesId: localStorage.getItem('adm'),
        isLogin: false,
        grub_id: parseInt(localStorage.getItem('grub_id')) || 0,
        role: localStorage.getItem('role') || ''
    }

    componentDidMount = () => {
        let maincontent = document.getElementById("main-content")
        maincontent.style.display = "none";

        // Cek apakah ada data login di localStorage
        if (this.state.aksesId == null) {
            window.location.replace('/')
        } else {
            // Bypass API - langsung set login berdasarkan localStorage
            const grub_id = parseInt(localStorage.getItem('grub_id')) || 1;
            const role = localStorage.getItem('role') || 'admin_akademik';

            localStorage.setItem('isLogin', true);
            maincontent.style.display = "block";

            this.setState({
                isLogin: true,
                grub_id: grub_id,
                role: role
            });
        }
    }

    render() {
        return (
            <Fragment>
                <ConfigAdmin />
                <div className="container-scroller" id='main-content'>
                    <Navbar />
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar grub_id={this.state.grub_id} role={this.state.role} />
                        <div className="main-panel">
                            <div className="content-wrapper">
                                {/* admin child routes  */}
                                {this.state.isLogin ? <AdminRoutes grub_id={this.state.grub_id} role={this.state.role} /> : null}
                            </div>
                            <Footer />
                        </div>
                    </div>
                    <AnimationLoader />
                </div>
            </Fragment>
        );
    }
}

export default Admin;
